import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GanttService extends BaseService<any> {

  constructor(public http: HttpClient) {
    super(http);
  }
  public getAgregador(id:number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/agregador/' + id, { headers: this.headers });
  }

  public getProjeto(id:number,history:number|null = null): Observable<any> {
    let historyUrl = '/' + id + '/' + history;
    let url = history? historyUrl : '/' + id;
    return this.http.get<any>(this.baseUrl + url, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/cronograma';
  }
}
